import * as _ from './salesorg.model';
import * as __ from './payer.model';
import { ContractModel } from '../contract/contract.model';
export class CustomerModel{
    cust_code:string
    cust_name:string
    address:string
    contact_no:string
    cust_grp_code:string
    outbal: string
    creditlimit: string
    so_blk_code: string
    so_blk_desc: string
    salesorg: _.SalesOrgModel
    payer: __.PayerModel
    pay_term_code:string
    pay_term_name:string
    tax_id:string
    total:number
    // partial_dlvy_flag:string
     acct_grp: string
     order_reason:string
     insertion_caterory_id: string
     default_pay_term_code: string
     is_contract_customer: boolean
     selected_contract: ContractModel
}



// WEBPACK FOOTER //
// ./src/models/customer/customer.model.ts